<template>
    <div>
        <div class="table_wrap">
            <div class="c_table_wrap table_search_wrap">
                <div class="filter-select-div el-filter-date mb11">
                    <span class="filter-select-span mr24">유형</span>
                    <span class="filter-select-div">
                    <el-select class="select" v-model="filterType" @change="handlerTypeSelect()">
                        <el-option value="" label="전체"></el-option>
                        <el-option value="premium" label="프리미엄"></el-option>
                        <el-option value="normal" label="일반"></el-option>
                    </el-select>
                </span>
                </div>


                <div class="filter-show-count">
                    <el-select v-model="size" @change="changeSize()">
                        <el-option v-for="(sizeData) in sizeList" :key="`size${sizeData}`" :value="sizeData"
                                   :label="`${sizeData}개씩 보기`"></el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <el-table class="list-table" header-cell-class-name="list-header" :data="List"
                  style="width: 100%;" height="695" empty-text="데이터가 없습니다.">
            <el-table-column
                class="table_no"
                type="index"
                label="No"
                min-width="70"
                class-name="num text-center"
                :index="tableIdx"
            >
            </el-table-column>
            <el-table-column label="유형" width="" class-name="text-center" prop="lngType">
                <template slot-scope="scope">
                    <span>
                        {{ scope.row.lngType === 'premium'? '프리미엄' : '일반' }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="요청자 닉네임" width="" class-name="text-center" prop="">
                <template slot-scope="scope">
                    <el-link v-if="UserKey !== scope.row.requestId" @click="moveProfile(scope.row, scope.row.requestId)">
                        {{getUsersNick(scope.row, scope.row.requestId)}}
                    </el-link>
                    <div class="row-info" v-else>본인</div>
                </template>
            </el-table-column>
            <el-table-column label="요청자 받은 첨삭" width="" class-name="text-center" prop="">
                <template slot-scope="scope" >
                    <div class="row-info">
                        <el-button v-if="isSendFeedback(scope.row, scope.row.receiverId)" @click="showFeedback(scope.row, scope.row.receiverId)">
                            보기
                        </el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="수락자 닉네임" width="" class-name="text-center" prop="">
                <template slot-scope="scope">
                    <el-link v-if="UserKey !== scope.row.receiverId" @click="moveProfile(scope.row, scope.row.receiverId)">
                        {{getUsersNick(scope.row, scope.row.receiverId)}}
                    </el-link>
                    <div class="row-info" v-else>본인</div>
                </template>
            </el-table-column>
            <el-table-column label="수락자 받은 첨삭" width="" class-name="text-center" prop="">
                <template slot-scope="scope">
                    <div class="row-info">
                        <el-button v-if="isSendFeedback(scope.row, scope.row.requestId)" @click="showFeedback(scope.row, scope.row.requestId)">
                            보기
                        </el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="일자" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{ returnDateUnix(scope.row.created / 1000, 'YYYY-MM-DD HH:mm') }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                label="녹음파일" width="85" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info">
                        <el-button @click="downloadRec(scope.row)">
                            다운로드
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagnation_wrap home-pagebar">
            <div class="inline-block" v-if="total > 0">
                <el-button class="pagebar-button" icon="el-icon-d-arrow-left" :disabled="page === 1" @click="setPage(1)"></el-button>
                <el-button class="pagebar-button" icon="el-icon-arrow-left" :disabled="page === 1" @click="setPage(page-1)"></el-button>
                <el-pagination
                    :page-size="size"
                    :current-page.sync="page"
                    :pager-count="11"
                    :total="total"
                    @current-change="setPage(page)"
                    class="bottom-pagebar"
                    layout="pager"
                    background>
                </el-pagination>
                <!--<el-button class="pagebar-button" icon="el-icon-arrow-right" :disabled="returnLastPage() === paginationData.page" @click="changePage(paginationData.page+1, 'page')"></el-button>
                <el-button class="pagebar-button" icon="el-icon-d-arrow-right" :disabled="returnLastPage() === paginationData.page" @click="changePage(returnLastPage(), 'page')"></el-button>-->
                <el-button class="pagebar-button" icon="el-icon-arrow-right" :disabled="page === returnLastPage()" @click="setPage(page+1)"></el-button>
                <el-button class="pagebar-button" icon="el-icon-d-arrow-right" :disabled="page === returnLastPage()" @click="setPage(returnLastPage())"></el-button>

            </div>
        </div>
        <correct-receive-modal></correct-receive-modal>
    </div>
</template>

<script>
import util from "@/mixins/util";
import dateMixins from "@/mixins/dateMixins";
import alertMixins from "@/mixins/alertMixins";
import {mapState, mapGetters} from "vuex";
import CorrectReceiveModal from "@/components/modal/CorrectReceiveModal";
import {fileDownloadS3} from "@/plugins/awsS3Record";

export default {
    name: "OnlineMemberFirebaseComponent",
    mixins: [dateMixins, alertMixins],
    components: {
        CorrectReceiveModal
    },
    inject: ['changeLoading'],
    provide() {
        return{

        }
    },
    props: {
        memberKey: {default: 0},
    },
    data() {
        return{
            filterDate: '',
            sizeList: [10, 30, 50],
            size: 10,

            selectArr: [],
            page: 1,
            total: 0,

            deleteIndex: 0,
            deleteLastIndex: 0,

            UserKey: '',
            allDataList: [],
            List: [],

            filterType: '',
        }
    },
    beforeRouterEnter() {},
    created() {
        this.initConfig();
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
        ...mapState({
            db: state => state.db,
        })
    },
    methods:{
        initConfig() {
            this.changeLoading(true);
            let params = {
                mt: "student",
                no: this.memberKey,
                ss: 1
            }
            this.$api.$member.getMember(params).then(res => res.Data.Result).then(res => {
                this.changeLoading(false);
                if(util.isEmpty(res.List)) {

                    this.createAlert({
                        content: '정보를 가져올 수 없습니다.',
                        hide: () => {
                            this.$router.back();
                        }
                    })
                    return false;
                }
                this.UserKey = res.List[0].mb_uuid;
                this.getData(this.UserKey)
            })
        },
        getData(docKey) {
            let userRecordRef = this.db.collection('users').doc(docKey).collection('record')
                .orderBy('created', "desc");
            userRecordRef.get().then(snap => {
                this.total = snap.size;
                snap.forEach(doc => {
                    let recordData = doc.data();
                    this.allDataList.push(recordData)
                    this.changeLoading(false)
                })
                this.setListData();
            })

        },
        setListData() {
            let startIndex = (this.page - 1) * this.size;
            let endIndex = this.page * this.size;
            let list = this.getAllDataList();
            this.total = list.length;
            this.List = list.slice(startIndex, endIndex);
        },
        getAllDataList() {
            let list = this.allDataList.slice();
            list = list.filter(adl => adl.talkType != 'freeTalk')
            if(this.filterType != '') {
                list = this.allDataList.filter(adl => adl.lngType === this.filterType)
            }

            return list;
        },
        changeSize() {
            this.page = 1;
            this.setListData();
        },
        handlerTypeSelect() {
            this.page = 1;
            this.setListData();
        },
        tableIdx(index) {
            return this.getAllDataList().length - index - (this.page - 1) * this.size;
        },
        getUsersNick(data, id) {
            if(util.isEmpty(data.users[id])) {
                return '';
            }
            return data.users[id].name;
        },
        isSendFeedback(data, id) {
            if(util.isEmpty(data.setFeedback) || util.isEmpty(data.setFeedback[id])) {
                return false;
            }
            return data.setFeedback[id];
        },
        moveProfile(data, id) {
            if(util.isEmpty(data.users[id]) || util.isEmpty(data.users[id].userIdx)) {
                return '';
            }
            this.$router.push(`/student/member/${data.users[id].userIdx}?tab=basic`);
        },
        returnLastPage() {
            return Math.ceil(this.total/this.size);
        },
        setPage(page) {
            this.page = page;
            this.setListData();
        },
        _getOnlineData(record, userId="") {
            let onlineRef = this.db.collection('onlineLngTransfer').doc(record.id)
            return onlineRef.get().then(doc => {
                let onlineData = doc.data();
                if(onlineData) {
                    onlineData.id = record.id;
                    if(userId != '') {
                        onlineData.partner = {mb_nick: this.getUsersNick(record, userId)};
                    }
                    return onlineData
                }else {
                    return null;
                }
            })
        },
        _getFeedbackData(onlineId, userId) {
            let returnData = {
                created: 0,
                data: [],
                onlng: onlineId,
                writer: userId,
            }
            let onlineFeedbackRef = this.db.collection('onlineLngTransfer').doc(onlineId)
                .collection('feedback').doc(userId);
            return onlineFeedbackRef.get().then(doc => {
                let feedbackData = doc.data();
                if(feedbackData) {
                    returnData = Object.assign({}, returnData, feedbackData);
                }
                return returnData;
            })
        },
        async showFeedback(record, userId) {
            this.changeLoading(true)
            let feedbackData = await this._getFeedbackData(record.id, userId)
            if(feedbackData.data.length === 0) {
                this.errorAlert('데이터가 없습니다.')
                return false;
            }
            let onlineData = await this._getOnlineData(record, userId);
            if(onlineData === null) {
                this.errorAlert('데이터가 없습니다.')
                return false;
            }
            this.changeLoading(false)
            this.$modal.show(
                'correct-receive-modal',
                {recordData: record, onlineData: onlineData, feedbackData: feedbackData}
            );
        },
        _getFileBlob(record, onlineData) {
            let option = {
                id: record.id,
            };
            let fileName = `${record.id}.mp3`;
            return fileDownloadS3(fileName, option).then(blob => {
                if(!blob) {
                    return this.checkAndRequestRecord(onlineData)
                }
                if(!onlineData.hasOwnProperty('record') || onlineData.record.status != 'success') {
                    this.setRecordSuccess(onlineData)
                }
                return blob;
            });
        },
        setRecordSuccess(onlineData) {
            let params = {"channel_id": onlineData.id};
            this.$api.$record.deleteJanusRecord(params);
            let record = onlineData.record;
            if(util.isEmpty(record) || util.isEmpty(record.tryDate)) {
                record = {
                    try: 0,
                    status: 'success',
                    tryDate: Date.now(),
                }
            }else{
                record.status = 'success'
            }
            this.$store.dispatch('lngTransfer/onlineCreate', {
                transferId: onlineData.id, users: [], data: {record: record},
            })
        },
        checkAndRequestRecord(onlineData) {
            let now = Date.now();
            let checkDate = now - (1000 * 60 * 30)
            let record = onlineData.record;
            if(util.isEmpty(record)) {
                record = {
                    try: 0,
                    status: 'ing',
                    tryDate: 0,
                }
            }
            if(record.tryDate < checkDate && record.try <= 3 && onlineData.status != 'finish') {
                let params = {"channel_id": onlineData.id};
                this.$api.$record.runRecord(params)
                record.try += 1;
                record.tryDate = now;
                this.$store.dispatch('lngTransfer/onlineCreate', {
                    transferId: onlineData.id, users: [], data: {record: record},
                })
                this.errorAlert("언어교환 녹음 저장중 입니다.")
                return false;
            } else if(record.try > 3 || onlineData.status === 'finish') {
                this.errorAlert('데이터가 없습니다.');
                return false;
            }else {
                this.errorAlert("언어교환 녹음 저장중 입니다.")
                return false;
            }
        },
        _makeFileName(record) {
            // let fileName = `KoreanSSam-${this.onlineData.partner.mb_nick}-${this.returnDateMiliTimezone(this.recordData.created)}.pdf`
            let requestNick = this.getUsersNick(record, record.requestId)
            let receiveNick = this.getUsersNick(record, record.receiverId)
            let fileName = `KoreanSSam-${requestNick}-${receiveNick}-${this.returnDateUnix(record.created/1000)}.mp3`;
            return fileName;
        },
        async downloadRec(record) {
            this.changeLoading(true);
            let onlineData = await this._getOnlineData(record);
            if(onlineData === null) {
                this.errorAlert('데이터가 없습니다.')
                this.changeLoading(false);
                return false;
            }
            let blob = await this._getFileBlob(record, onlineData);
            if(!blob) {
                this.errorAlert('데이터가 없습니다.')
                this.changeLoading(false);
                return false;
            }
            let fileName = this._makeFileName(record);
            const a = document.createElement("a");
            a.style.display = "none";
            document.body.appendChild(a)
            a.href = window.URL.createObjectURL(blob);
            a.setAttribute("download", fileName);
            a.click();
            window.URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
            this.changeLoading(false);
        },
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
